import { render } from "./DetalleAseguradora.vue?vue&type=template&id=6a0fc2e8&scoped=true"
import script from "./DetalleAseguradora.vue?vue&type=script&lang=js"
export * from "./DetalleAseguradora.vue?vue&type=script&lang=js"

import "./DetalleAseguradora.vue?vue&type=style&index=0&id=6a0fc2e8&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0fc2e8"]])

export default __exports__